import React, { Component } from 'react';
import { Menu, Dropdown } from 'antd';
import './FolderTabs.scss';

class FolderTabs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            splitNum: 5,
        };
    }
    componentDidMount () {}
    handleTab (data) {
        const { folders } = this.props;
        const index = folders.indexOf(data);
        folders.splice(index + 1);
        this.setState({ folders });
        const onChange = this.props.onChange;
        onChange && onChange(folders);
    }
    render () {
        const { splitNum } = this.state;
        const { folders } = this.props;

        if (folders.length > splitNum) {
            const _folders = folders.concat();
            const fronts = _folders.splice(0, _folders.length - splitNum);
            const backs = _folders;
            return (<ul className='folder-list'>
                <li>
                    <Dropdown overlayClassName='storage-ant-dropdown' overlay={
                        <Menu>
                            {
                                fronts.map(item => <Menu.Item key={item.id} onClick={()=>this.handleTab(item)}>{item.name}</Menu.Item>)
                            }
                        </Menu>
                    }><a className="wc-icon-btn folder-open"></a></Dropdown>
                </li>
                {
                    backs.map(item=><li key={item.docId} onClick={()=>this.handleTab(item)}><span>{item.name}</span></li>)
                }
            </ul>);
        } else {
            return (
                <ul className='folder-list'>
                    {
                        folders.map(folder=><li key={folder.docId} onClick={()=>this.handleTab(folder)}><span>{folder.name}</span></li>)
                    }
                </ul>
            );
        }
    }
}
export default FolderTabs;
